export const sidebarTracker = {
  actions: {
    modalReportKey: 'Menu Lateral esquerdo: Reportar erro',
    expandSidebar: 'Expandir Sidebar',
  },
}
